import VeeValidate from 'vee-validate';
import th from './lang/validator/th';
import en from './lang/validator/en';

// config validator
VeeValidate.Validator.extend('namespace', {
  getMessage: field => `The ${field} must contain 3-32 characters, can be lowercase, dash and numbers`,
  validate: value => (value !== null && value.match('^[a-z0-9][a-z0-9\\-]+[a-z0-9]$') !== null),
});

VeeValidate.Validator.extend('custom_price_between', {
  getMessage: (field, [min, max], value) => {
    if (Number(value) < Number(min)) {
      return `Please refill at least ${Number(min).toLocaleString()} THB.`;
    } else if (Number(value) > Number(max)) {
      return `Please contact ByteArk if you want to refill more than ${Number(max).toLocaleString()} THB`;
    }
    return `The ${field} field must be between ${Number(min).toLocaleString()} and ${Number(max).toLocaleString()}.`;
  },
  validate: (value, [min, max]) => {
    return new Promise((resolve) => {
      resolve({
        valid: (Number(min) <= value && Number(max) >= value),
        data: value,
      });
    });
  },
});

// extend error bag to support error from Laravel
VeeValidate.ErrorBag.prototype.addAll = function(errors) {
  Object.keys(errors).forEach((key) => {
    const messages = errors[key];
    if (messages.length > 0) {
      this.add.call(this, key, messages[0], '');
    }
  });
};

// add thai locale
VeeValidate.Validator.addLocale(th);
VeeValidate.Validator.addLocale(en);

const VeeValidateConfig = {
  locale: 'th',
};

export default VeeValidateConfig;



// WEBPACK FOOTER //
// ./src/validator.js